import Vue from "vue";
import Antd from "ant-design-vue/lib";
import "../../../../../themes/finanum/theme.less";

Vue.use(Antd);
